var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235.86 68.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05D3\\u05E3_\\u05D4\\u05D1\\u05D9\\u05EA",
    "data-name": "\\u05D3\\u05E3 \\u05D4\\u05D1\\u05D9\\u05EA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.76,21.18H3.36v-9.18h27.72v36h-10.32v-26.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.18,12v17.64c0,12.12-7.92,19.5-21.12,19.5s-21.12-7.38-21.12-19.5V12h10.14v9.66h5.94v-9.66h9.72v18.6h-15.6c.36,5.7,4.5,9.06,10.92,9.06,6.78,0,10.98-3.72,10.98-10.02V12h10.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.34,12l-13.68,36.72-9.6-3.72,9.06-23.82h-22.32v-9.18h36.54ZM88.8,27.3h10.32v29.7h-10.32v-29.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.66,12h10.32v36h-10.32V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.04,21.18h-17.4v-9.18h27.72v36h-10.32v-26.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.44,38.82h16.38l-17.82-21.6,7.56-6.42,11.46,14.34,11.46-14.58,7.38,5.7-12.84,16.32,12.18,15.24v.18h-35.76v-9.18Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/צרו קשרmdpi.e6880cc669e313527d06825544eb3ea9.svg";
export { ForwardRef as ReactComponent };